module.exports = __webpack_public_path__ + "static/img/download.a89b6ff9.svg";